module.exports = __webpack_public_path__ + "static/icon-campaign-5-9af4c18aa5d34fb02065234f244ec6db.png";